import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';

function ExploreCollections() {
    return (
        <div id="wrapper">
            {/* Header component */}
            <Header />

            {/* content begin */}
            <div className="no-bottom no-top" id="content">

                {/* section begin */}
                <section id="subheader" className="minimal">
                    <div className="center-y relative text-center">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <h1>Collections</h1>
                                    {/* <p>Anim pariatur cliche reprehenderit</p> */}
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* section close */}

                <section aria-label="section" id="section-explore">
                    <div className="container" >
                        <div className="row cols-5 wow fadeIn animated">
                            {/* NFT items */}
                            <div className="d-item col-sm-6 col-md-4 col-lg-2-5">
                                <div class="owl-item active"><div class="nft_coll">
                                    <div class="nft_wrap">
                                        <a href="/collection"><img src="https://f8n-production-collection-assets.imgix.net/8453/0x1B592bD55ebA83719e224Bd54E1753c51D9fe834/1/nft.png?q=50&auto=format%2Ccompress&cs=srgb&h=640" class="lazy img-fluid" alt="" /></a>
                                    </div>
                                    <div class="nft_coll_pp">
                                        <a href="/collection"><img class="lazy pp-coll" src="images/author/author-11.jpg" alt="" /></a>
                                        <i class="fa fa-check"></i>
                                    </div>
                                    <div class="nft_coll_info">
                                        <a href="/collection"><h3>Gilding Faces</h3></a>
                                        <span>@NFTtalks</span>
                                    </div>
                                </div></div>
                            </div>

                            {/* Additional NFT items go here following the same pattern */}

                            <div className="col-md-12 text-center">
                                {/* <a href="#" id="loadmore" className="btn-main wow fadeInUp lead animated" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Load more</a> */}
                                <a href="#" id="loadmore" class="btn-list">View more</a>                            
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {/* content close */}

            {/* Footer */}
            <Footer />
        </div>
    );
}

export default ExploreCollections;